<template>
  <KTCodePreview v-bind:title="'Tải lên Hình ảnh'">
    <template v-slot:preview>
      <b-container>
        <b-row>
          <b-col cols="12">
            <image-uploader @upload-complete="handleUploadComplete" />
          </b-col>
        </b-row>

        <b-row v-if="showRecent" class="mt-4">
          <b-col cols="12">
            <h2 class="h5 mb-3">Hình ảnh vừa tải lên</h2>
            <image-grid :images="recentImages" />
          </b-col>
        </b-row>

        <!-- Thông tin hướng dẫn -->
        <div class="alert alert-info" v-else>
          <h6 class="alert-heading">Lưu ý:</h6>
          <ul class="mb-0 pl-3">
            <!-- <li>Hình ảnh đầu tiên sẽ được sử dụng làm ảnh đại diện</li> -->
            <li>Nên sử dụng hình ảnh có tỷ lệ 1:1 để hiển thị tốt nhất</li>
            <li>Tối đa 10 hình ảnh cho mỗi sản phẩm</li>
          </ul>
        </div>
      </b-container>
    </template>
  </KTCodePreview>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ImageUploader from '@/view/components/images/ImageUploader';
import ImageGrid from '@/view/components/images/ImageGrid';
import { makeToastSuccess } from '@/utils/common';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

export default {
  name: 'ImageUpload',
  components: {
    ImageUploader,
    ImageGrid,
    KTCodePreview,
  },
  data() {
    return {
      showRecent: false,
    };
  },
  computed: {
    ...mapGetters('images', ['allImages']),

    recentImages() {
      return [...this.allImages]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 8);
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Tải lên Hình ảnh' }]);
  },
  methods: {
    ...mapActions('images', ['fetchImages']),

    handleUploadComplete({ success }) {
      if (success > 0) {
        makeToastSuccess(`Successfully uploaded ${success} images`);
        // Refresh images and show recent uploads
        this.fetchImages().then(() => {
          this.showRecent = true;
        });
      }
    },
  },
  created() {
    this.fetchImages();
  },
};
</script>
